import { isEmpty, some } from 'lodash/fp';

import { MemberPerk } from '../../../../types/__codegen__/sanity/graphql';

const hasLandingPage = (perk: MemberPerk) => !some(isEmpty, [perk?.descriptionTeaser, perk?.name, perk?.slogan]);

export default hasLandingPage;
